<template>
  <div class="assessSuccess">
    <van-nav-bar
      title="全部订单"
      right-text="筛选"
      fixed
      placeholder
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
    />
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :immediate-check="false"
        offset="10"
        @load="onLoad"
      >
        <van-cell v-for="(item, index) in orderList" :key="index">
          <div @click="finishedtioa(item.sn)">
            <div class="number-style">
              <div>{{ item.sn }}</div>
              <div>{{ item.createTime }}</div>
            </div>

            <div class="happening">
              <p>{{ item.projectName }}</p>
              <div class="assess-p">
                <img src="../../assets/qidian.png" />
                <p>{{ item.projectUpAddress }}</p>
              </div>
              <div class="assess-p">
                <img src="../../assets/zhongdian.png" />
                <p>{{ item.projectDownAddress }}</p>
              </div>
            </div>

            <div
              v-show="item.orderStatusName == '已完成'"
              style="color: #cac9cc"
            >
              <van-cell
                :title="item.orderStartTime"
                :value="
                  parseLen(parseInt(item.servicePeriod / 60 / 60)) +
                  ':' +
                  parseLen(parseInt((item.servicePeriod / 60) % 60)) +
                  ':' +
                  parseLen(parseInt(item.servicePeriod % 60))
                "
              />
              <van-cell
                :title="item.orderEndTime"
                :value="item.serviceDistance + 'km'"
              />
            </div>
            <van-cell class="project">
              <van-tag class="tag" color="#9EA0A5">{{
                item.projectServiceName
              }}</van-tag>
              <van-tag class="tag" color="#9EA0A5">{{
                item.orderStatusName
              }}</van-tag>
            </van-cell>

            <div class="happening" v-if="item.remarks !== ''">
              <span>{{ item.remarks }}</span>
            </div>
          </div>
          <van-button
            @click="complaint(item.sn, item.useCarTime)"
            style="width: 100px; height: 40px; float: right"
            >投诉反馈</van-button
          >
        </van-cell>
      </van-list>
    </van-pull-refresh>
    <!--  弹出层 -->
    <van-popup
      v-model="show"
      closeable
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div class="shuai">
        <p>订单状态</p>
        <van-checkbox-group
          v-model="statusChecked"
          direction="horizontal"
          @change="changeStatus"
        >
          <van-checkbox
            v-for="(item, index) in orderStatus"
            :key="index"
            :name="item.value"
            >{{ item.label }}</van-checkbox
          >
        </van-checkbox-group>
      </div>
      <!-- <div class="shuai">
  		<p>服务类型:</p>
  		<van-checkbox-group v-model="seriveChecked" direction="horizontal" @change="changeSerive" class="grid">
  			<van-checkbox v-for="(item, index) in seriveList" :key="index" :name="item.value">{{ item.label }}
  			</van-checkbox>
  		</van-checkbox-group>
  	</div> -->
      <!-- <div class="shuai">
  		<p>其他费用:</p>
  		<van-checkbox-group v-model="costChecked" direction="horizontal" @change="changeCost">
  			<van-checkbox v-for="(item, index) in costList" :key="index" :name="item.value">{{ item.label }}
  			</van-checkbox>
  		</van-checkbox-group>
  	</div> -->
      <!-- <div class="shuai">
  		<p>下单时间:</p>
  		<van-cell title="开始时间" :value="dateStart" @click="showStart = true" />
  		<van-calendar v-model="showStart" @confirm="onConfirmStart" :min-date="minDateStart" :max-date="maxDateStart" />
  		<van-cell title="结束时间" :value="dateEnd" @click="showEnd = true" />
  		<van-calendar v-model="showEnd" @confirm="onConfirmEnd" :min-date="minDateEnd" :max-date="maxDateEnd" />
  	</div> -->
      <div class="shuai">
        <!-- <p style="font-size: 16px;margin-top: 20px;">用车时间</p> -->
        <van-field
          readonly
          clickable
          is-link
          :colon="true"
          label="开始时间"
          label-width="4.5em"
          :value="timeValueSpecial"
          placeholder="输入开始时间"
          @click="showPopupSpecial"
        />

        <van-popup v-model="showSpecial" position="bottom">
          <van-datetime-picker
            v-model="currentDateSpecial"
            type="datetime"
            :loading="isLoadingShow"
            title="开始时间"
            :formatter="formatter"
            @cancel="showSpecial = false"
            @confirm="confirmPickerSpecial"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          is-link
          :colon="true"
          label-width="4.5em"
          label="结束时间"
          :value="timeValueGuest"
          placeholder="请选择结束时间"
          @click="showPopupGuest"
        />
        <van-popup v-model="showGuest" position="bottom">
          <van-datetime-picker
            v-model="currentDateGuest"
            type="datetime"
            :loading="isLoadingShow"
            :formatter="formatter"
            @cancel="showGuest = false"
            @confirm="confirmPickerGuest"
          />
        </van-popup>

        <!-- <van-cell title="开始时间" :value="useDateStart" @click="useShowStart = true" />
  		<van-calendar v-model="useShowStart" @confirm="onUseConfirmStart" :min-date="minUseDateStart" :max-date="maxUseDateStart" />
  		<van-cell title="结束时间" :value="useDateEnd" @click="useShowEnd = true" />
  		<van-calendar v-model="useShowEnd" @confirm="onUseConfirmEnd" :min-date="minUseDateEnd" :max-date="maxUseDateEnd" /> -->
      </div>
      <van-button type="primary" @click="submit">确定</van-button>
      <van-button type="info" @click="close">取消</van-button>
    </van-popup>

   <!-- <van-overlay :show="showopen" >
     <img src="../../assets/61.png" class="openimg" @click="openget" />
	 <img src="../../assets/7.png" class="openimgx" @click="showopen = false" >
  </van-overlay> -->
  </div>
</template>
<script>
import {
  NavBar,
  Cell,
  Field,
  Tag,
  Popup,
  Button,
  Checkbox,
  Dialog,
  CheckboxGroup,
  List,
  DatetimePicker,
  PullRefresh
  // Overlay
} from "vant";
export default {
  name: "allorders",
  data() {
    return {
      showopen:true,
      pageNum: 1,
      pageSize: 10,
      loading: false,
      finished: false,
      refreshing: false,
      // 字典
      dictionary: [],
      // 订单状态选中后的值
      selectedOrders: [],
      // 其他费用选中后的值
      selectedCost: [],
      // 服务类型选中后的值
      selectedtype: [],
      // 渲染订单状态的列表
      orderStatus: [],
      // 服务类型选中的默认值
      seriveChecked: [],
      // 其他费用的默认值
      costChecked: [],
      // 订单状态选中的默认值
      statusChecked: [],
      //  渲染服务类型的列表
      seriveList: [],
      // 渲染其他费用的列表
      costList: [],
      // 订单状态的列表
      orderList: [],
      dateStart: null,
      dateEnd: null,
      useDateStart: null,
      useDateEnd: null,
      // minDateStart: new Date(1999, 0, 1),
      // maxDateStart: new Date(2210, 0, 31),
      // minDateEnd: new Date(1999, 0, 1),
      // maxDateEnd: new Date(2210, 0, 31),
      // minUseDateStart: new Date(1999, 0, 1),
      // maxUseDateStart: new Date(2210, 0, 31),
      // minUseDateEnd: new Date(1999, 0, 1),
      // maxUseDateEnd: new Date(2210, 0, 31),
      addOrderStartTime: null,
      addOrderEndTime: null,
      userCarStartTime: null,
      userCarEndTime: null,
      show: false,
      showSpecial: false,
      showGuest: false,
      isLoadingShow: true,
      showStart: false,
      showEnd: false,
      currentDateSpecial: new Date(),
      minDateSpecial: new Date(),
      maxDateSpecial: new Date("2030/01/01"),
      currentDateGuest: new Date(),
      minDateGuest: new Date(),
      maxDateGuest: new Date("2030/01/01"),
      showCascader: false,
      timeValueSpecial: "",
      timeValueGuest: "",
      useShowStart: false,
      useShowEnd: false,
      isActive: 0,
      zhongdian: require("@/assets/zhongdian.png"),
      qidian: require("@/assets/qidian.png"),
      accountId: localStorage.getItem("accountUid"),
      accountType: localStorage.getItem("identify"),
      listObj: [
        {
          id: 1,
          name: "zs1",
        },
        {
          id: 2,
          name: "zs2",
        },
        {
          id: 3,
          name: "zs3",
        },
        {
          id: 4,
          name: "zs4",
        },
        {
          id: 5,
          name: "zs5",
        },
        {
          id: 6,
          name: "zs6",
        },
      ],
    };
  },
  mounted() {
    this.order();
	  // this.delCookie();//调用
  },
  created() {
    this.status(), this.cost(), this.serive();
    //弹出框
    // if (this.getCookie('popped') == ''){ //cookie 中没有 popped 则赋给他一个值（此时弹框显示）
    //    document.cookie = "popped = yes";
    //   }else{
    //    this.showopen = false; //若cookie 中已经有 popped 值，则弹框再不会显示
    //   }
	
  },
  methods: {
    // noPopup(){
    //     this.showopen = false;
    //    },
    //    getCookie(Name) { //cookie
    //     var search = Name + "=";
    //     var returnValue = "";
    //     if (document.cookie.length > 0) {
    //      var offset = document.cookie.indexOf(search);
    //      if (offset !== -1) {
    //       offset += search.length;
    //       var end = document.cookie.indexOf(";", offset);
    //       if (end == -1){
    //        end = document.cookie.length;
    //       }
    //       returnValue = decodeURIComponent(document.cookie.substring(offset, end));
    //      }
    //     }
    //     return returnValue;
    //    },
	   
	   
	   
	   
	 // // 清空cookie  
	 // delCookie() {
	 //       var cookies = document.cookie.split(";");
	 //       for (var i = 0; i < cookies.length; i++) {
	 //         var cookie = cookies[i];
	 //         var eqPos = cookie.indexOf("=");
	 //         var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
	 //         document.cookie =
	 //           name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
	 //       }
	 //       if (cookies.length > 0) {
	 //         for (var i = 0; i < cookies.length; i++) {
	 //           var cookie = cookies[i];
	 //           var eqPos = cookie.indexOf("=");
	 //           var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
	 //           var domain = location.host.substr(location.host.indexOf("."));
	 //           document.cookie =
	 //             name +
	 //             "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=" +
	 //             domain;
	 //         }
	 //       }
	 //     },

	   
	   
    // openget() {
    //   this.$router.push({
    //     name: "advertisement",
    //   });
    // },
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      } else if (type === "day") {
        return `${value}日`;
      }
    },
    confirmPickerSpecial(val) {
      let year = val.getFullYear();
      let month =
        val.getMonth() + 1 < 10
          ? "0" + (val.getMonth() + 1)
          : val.getMonth() + 1;
      let day = val.getDate() < 10 ? "0" + val.getDate() : val.getDate();
      // let hour = val.getHours();
      // let minute = val.getMinutes();
      this.timeValueSpecial = `${year}-${month}-${day} 00:00:00`;
      this.showSpecial = false;

      console.log(this.timeValueSpecial, "222");
    },
    showPopupSpecial() {
      this.showSpecial = true;
      this.isLoadingShow = true;
      setTimeout(() => {
        this.isLoadingShow = false;
      }, 500);
    },
    confirmPickerGuest(val) {
      let year = val.getFullYear();
      let month =
        val.getMonth() + 1 < 10
          ? "0" + (val.getMonth() + 1)
          : val.getMonth() + 1;
      let day = val.getDate() < 10 ? "0" + val.getDate() : val.getDate();
      // let hour = val.getHours();
      // let minute = val.getMinutes();
      this.timeValueGuest = `${year}-${month}-${day} 00:00:00`;
      this.showGuest = false;
    },
    showPopupGuest() {
      this.showGuest = true;
      this.isLoadingShow = true;
      setTimeout(() => {
        this.isLoadingShow = false;
      }, 500);
    },
    onClickLeft() {
      window.open("app:/#/finish");
    },
    //转化时分秒
    parseLen(v) {
      return v > 9 ? v : "0" + v;
    },
    // 投诉
    complaint(sn, useCarTime) {
      this.$axios
        .get(
          `vedm/accountCommonApp/orderEvaluationBySn/${sn}/${this.accountId}`,
          {
            headers: {
              Authorization: localStorage.getItem("token"), //token换成从缓存获取
            },
          }
        )
        .then((res) => {
          console.log(res.data.data);
          if (res.data.data == "COMPLAINT_FEEDBACK_STATUS-PERFECTION") {
            Dialog({
              message: res.data.msg,
            });
          } else if (res.data.data == "COMPLAINT_FEEDBACK_STATUS-PENDING") {
            Dialog({
              message: res.data.msg,
            });
          } else {
            window.open("app:/#/order_feedback?" + sn + "&" + useCarTime);
          }
        });
    },

    // 订单详情
    finishedtioa(sn) {
      if (localStorage.getItem("identify") == "engineer") {
        this.$router.push({
          path: "/allorderslist",
          query: {
            sn: sn,
            returtlist: "1",
          },
        });
      } else {
        this.$router.push({
          path: "/allorderslist_driver",
          query: {
            sn: sn,
            returtlist: "1",
          },
        });
      }
    },

    // 订单状态
    status() {
      this.$axios
        .get("/admin/dict/type/vedm_order_status", {
          headers: {
            Authorization: localStorage.getItem("token"), //token换成从缓存获取
          },
        })
        .then((res) => {
          this.orderStatus = res.data.data;
        });
    },
    // 其他费用
    cost() {
      this.$axios
        .get("/admin/dict/type/vedm_order_cost_type", {
          headers: {
            Authorization: localStorage.getItem("token"), //token换成从缓存获取
          },
        })
        .then((res) => {
          this.costList = res.data.data;
        });
    },
    // 服务类型
    serive() {
      this.$axios
        .get("/admin/dict/type/vedm_company_work_type", {
          headers: {
            Authorization: localStorage.getItem("token"), //token换成从缓存获取
          },
        })
        .then((res) => {
          this.seriveList = res.data.data;
        });
    },
    //  选中状态
    changeStatus(statusItem) {
      this.selectedOrders = statusItem;
    },
    // 服务类型
    changeSerive(seriveItem) {
      this.selectedtype = seriveItem;
    },
    // 其他费用
    changeCost(costItem) {
      this.selectedCost = costItem;
    },
    // 确定提交(筛选)
    submit() {
      if (
        this.selectedOrders == "" &&
        this.selectedtype == "" &&
        this.selectedCost == ""
      ) {
        Dialog({ message: "至少选中一项查询" });
      } else {
        this.$axios
          .post("/vedm/orderH5App/accountOrder", {
            headers: {
              Authorization: localStorage.getItem("token"), //token换成从缓存获取
            },
            accountId: this.accountId,
            accountType: this.accountType,
            addOrderStartTime: this.dateStart,
            addOrderEndTime: this.dateEnd,
            userCarStartTime: this.useDateStart,
            userCarEndTime: this.useDateEnd,
            serviceType: this.selectedtype,
            costType: this.selectedCost,
            orderStatus: this.selectedOrders,
            pageSize: this.pageSize,
            pageNum: this.pageNum,
          })
          .then((res) => {
            console.log(res.data.data, "筛选");
            this.orderList = res.data.data.records;
            if (res.data.data.records == "") {
              Dialog({ message: "暂无订单" });
            }
          });
        this.show = false;
      }
    },
    onClickRight() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
    // 数据列表
    async order() {
      this.pageNum = 1;
      this.$axios
        .post("/vedm/orderH5App/accountOrder", {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          headers: {
            Authorization: localStorage.getItem("token"), //token换成从缓存获取
          },
          accountId: localStorage.getItem("accountUid"),
          accountType: this.accountType,
        })
        .then((res) => {
          this.orderList = res.data.data.records;
          console.log(this.orderList);
          if (res.data.data.total === this.orderList.length) {
            this.finished = true;
          } else {
            this.finished = false;
          }
          this.pageNum = 1;
          this.refreshing = false;
          this.loading = false;
        })
        .catch(function (error) {
          console.log(error);
          window.app.showReLoginDialog();
        });
    },
    // 上拉加载
    onLoad() {
      this.$axios
        .post("/vedm/orderH5App/accountOrder", {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          headers: {
            Authorization: localStorage.getItem("token"), //token换成从缓存获取
          },
          accountId: localStorage.getItem("accountUid"),
          accountType: this.accountType,
        })
        .then((res) => {
          let datas = res.data.data.records;
          // this.orderList = this.orderList.concat(datas);
          // console.log(this.orderList);
          if (res.data.data.current > 1) {
            this.orderList = this.orderList.concat(datas);
          }
          if (this.orderList.length < res.data.data.total) {
            this.pageNum++;
            this.loading = false;
          } else {
            this.finished = true;
            this.loading = true;
          }
        })
        .catch(function (error) {
          console.log(error);
          window.app.showReLoginDialog();
        });
    },
    // 下拉刷新
    onRefresh() {
      this.order();
    },
    //下单的开始时间
    formatDateStart(dateStart) {
      return `${dateStart.getFullYear()}-${
        dateStart.getMonth() + 1 < 10
          ? "0" + (dateStart.getMonth() + 1)
          : dateStart.getMonth() + 1
      }-${
        dateStart.getDate() < 10
          ? "0" + dateStart.getDate()
          : dateStart.getDate()
      } 00:00:00`;
    },
    onConfirmStart(dateStart) {
      this.showStart = false;
      this.dateStart = this.formatDateStart(dateStart);
      console.log(this.dateStart);
    },
    //下单的结束时间
    formatDateEnd(dateEnd) {
      return `${dateEnd.getFullYear()}-${
        dateEnd.getMonth() + 1 < 10
          ? "0" + (dateEnd.getMonth() + 1)
          : dateEnd.getMonth()
      }-${
        dateEnd.getDate() < 10 ? "0" + dateEnd.getDate() : dateEnd.getDate()
      } 00:00:00`;
    },
    onConfirmEnd(dateEnd) {
      this.showEnd = false;
      this.dateEnd = this.formatDateEnd(dateEnd);
      console.log(this.dateEnd);
    },
    //用车的开始时间
    formatUseDateStart(useDateStart) {
      return `${useDateStart.getFullYear()}-${
        useDateStart.getMonth() + 1 < 10
          ? "0" + (useDateStart.getMonth() + 1)
          : useDateStart.getMonth() + 1
      }-${
        useDateStart.getDate() < 10
          ? "0" + useDateStart.getDate()
          : useDateStart.getDate()
      } 00:00:00`;
    },
    onUseConfirmStart(useDateStart) {
      this.useShowStart = false;
      this.useDateStart = this.formatUseDateStart(useDateStart);
      console.log(this.useDateStart);
    },
    //用车的结束时间
    formatUseDateEnd(useDateEnd) {
      return `${useDateEnd.getFullYear()}-${
        useDateEnd.getMonth() + 1 < 10
          ? "0" + (useDateEnd.getMonth() + 1)
          : useDateEnd.getMonth() + 1
      }-${
        useDateEnd.getDate() < 10
          ? "0" + useDateEnd.getDate()
          : useDateEnd.getDate()
      } 00:00:00`;
    },
    onUseConfirmEnd(useDateEnd) {
      this.useShowEnd = false;
      this.useDateEnd = this.formatUseDateEnd(useDateEnd);
      console.log(this.useDateEnd);
    },

    btnClick: function (index) {
      this.isActive = index;
    },
  },
  components: {
    "van-nav-bar": NavBar,
    "van-cell": Cell,
    "van-tag": Tag,
    "van-popup": Popup,
    "van-button": Button,
    "van-checkbox-group": CheckboxGroup,
    "van-checkbox": Checkbox,
    [Dialog.Component.name]: Dialog.Component,
    "van-list": List,
    "van-field": Field,
    "van-datetime-picker": DatetimePicker,
    "van-pull-refresh": PullRefresh,
    // "van-overlay":Overlay
  },
};
</script>

<style scoped lang="less">
.grid {
  display: grid;
  grid-template-columns: 120px 120px 120px;
  grid-template-rows: 30px;
  // grid-template-columns属性定义每一列的列宽，grid-template-rows属性定义每一行的行高。
}

.assess-p {
  color: #87838f;
}

.number-style {
  font-size: 14px;
  display: flex;
  justify-content: space-around;
  background-color: white;
  color: #cac9cc;
}

.assessSuccess {
  background: rgba(247, 247, 247, 1);

  .project {
    align-items: center;

    .number {
      display: block;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(158, 160, 165, 1);
    }

    .name {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(33, 37, 41, 1);
      margin: 0;
    }

    .tag {
      margin-left: 10px;
    }

    .tagRight {
      background: rgba(255, 149, 0, 0.1);
      border-radius: 2px;
      border: 1px solid rgba(255, 149, 0, 1);
      font-size: 11px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 149, 0, 1);
      margin-right: 5px;
    }

    .spanRight {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(33, 37, 41, 1);
    }
  }

  .shuai {
    overflow: hidden;
    font-size: 0.12rem;
    margin-top: 20px;
  }

  .van-checkbox--horizontal {
    font-size: 14px;
    margin-top: 10px;
    margin-left: 10px;
  }

  .shuai p {
    font-size: 14px;
    padding-left: 15px;
  }

  .van-checkbox__label {
    font-size: 14px;
  }

  .shuai ul li {
    width: 78px;
    height: 28px;
    background: #ccc;
    float: left;
    line-height: 28px;
    color: #fff;
    text-align: center;
    margin-left: 10px;
    margin-top: 10px;
  }

  .van-button {
    width: 150px;
    height: 40px;
    margin-left: 25px;
    margin-top: 20px;
  }

  .happening {
    // width: 375px;
    background: rgba(255, 255, 255, 1);
    padding-left: 15px;

    p {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      margin: 0;
      margin-bottom: 10px;
      line-height: 25px;
    }

    span {
      display: block;
      width: 100%;
      height: 80px;
      background: #f8f6f9;
      font-size: 14px;
      border-radius: 10px;
      padding: 10px;
      text-indent: 1em;
    }

    img {
      width: 30px;
      height: 30px;
      float: left;
    }

    .div {
      width: 104px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      border-radius: 14px;
      border: 1px solid rgba(232, 233, 235, 1);
      margin: 0 auto;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(33, 37, 41, 1);
    }

    .options {
      width: 345px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 24px;
    }

    .item {
      height: 28px;
      line-height: 28px;
      text-align: center;
      border-radius: 6px;
      padding: 0 20px;
      border: 1px solid rgba(232, 233, 235, 1);
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(98, 104, 112, 1);
    }
  }
}
.openimg {
  width: 300px;
  height: 350px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.openimgx {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: -52%;
  margin: auto;
}
</style>
